<!-- About us Start -->
<section class="section why-choose-us" id="about">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="title text-center" style="padding-bottom:8rem">
          <h1>100+ Global Companies <br />
            Have Chosen Us</h1>

          <div class="row mt-5">
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/octg.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/apple.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/cp1.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/gsk.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/discovery.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/pscu.svg" alt="octg" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/boa.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/citigroup.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/pwc.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/everie.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/sabreholdings.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/icglobal.svg" alt="octg" />
            </div>
          </div>

          <div class="row mt-3 justify-content-center">
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/censop.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/astericks.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/cadncad.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/via.svg" alt="octg" />
            </div>
            <div class="col-lg-2 justify-content-center align-self-center img-holder">
              <img src="../../../assets/images/brands/jpmorgan.svg" alt="octg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container>
    Ignore
  </ng-container>

  <div class="svg-container-2">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="#FAF5FF" />
    </svg>
  </div>
</section>
<!-- About us End -->
